import { Injectable } from '@angular/core';
import { environment } from '@rocksoft/environment';
import { HubService } from './hub.service';

@Injectable({ providedIn: 'root' })
export class InRoomHubService extends HubService {
  constructor() {
    super(`${environment.inroom.api}/hubs/roomstatus`);
  }
}
